export const PLACEHOLDER = {
  TITLE: 'No records found',
  DESCRIPTION: 'When you create a saved report, they will show up here.',
  CREATE: 'Create Report Profile',
};
